import FunctionWrapper from './function/FunctionWrapper';

interface FunctionMap {
  [key: string]: (args: any) => void;
}

export type FunctionType = 'form' | 'report' | 'process';

export default class FunctionManager {
  public functionMap: FunctionMap;
  private wrapper: FunctionWrapper;

  constructor() {
    this.functionMap = {};
    this.wrapper = new FunctionWrapper();
  }

  public register(defineId: string, fun: (args: any) => void, type: FunctionType) {
    this.functionMap[defineId] = this.wrapper.wrap(fun, type);
  }
}
